import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import { usePreloadedQuery} from 'react-relay'

import DeleteAccount from '../../../components/DeleteAccount'
import EmailNotifications from '../../../components/EmailNotifications'
import Panel from '../../../components/Panel/Panel'
import PasswordResetLink from '../../../components/PasswordResetLink'
import useDocumentTitle from '../../../hooks/useDocumentTitle'
import {PALETTE} from '../../../styles/paletteV3'
import {AuthIdentityTypeEnum, Layout} from '../../../types/constEnums'
import UserSettingsForm from './UserSettingsForm/UserSettingsForm'
import UserSettingsWrapper from './UserSettingsWrapper/UserSettingsWrapper'

const SettingsBlock = styled('div')({
  width: '100%'
})

const PanelRow = styled('div')({
  borderTop: `1px solid ${PALETTE.SLATE_300}`,
  padding: Layout.ROW_GUTTER,
  textAlign: 'center'
})






const query = graphql`
  query UserProfileQuery {
    viewer {
      ...PasswordResetLink_viewer
      ...EmailNotifications_viewer
      preferredName
      picture
      identities {
        type
      }
    }
  }
`

const UserProfile = ({queryRef}) => {
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const {identities} = viewer
  const isLocal = _optionalChain([identities, 'optionalAccess', _ => _.find, 'call', _2 => _2((identity) => _optionalChain([identity, 'optionalAccess', _3 => _3.type]) === AuthIdentityTypeEnum.LOCAL)])
  useDocumentTitle('My Profile | Parabol', 'My Profile')
  return (
    _jsx(UserSettingsWrapper, { children: 
      _jsxs(SettingsBlock, { children: [
        _jsx(Panel, { label: "Profile", casing: 'capitalize', children: 
          _jsx(UserSettingsForm, { viewer: viewer,} )
        })
        , isLocal && (
          _jsx(Panel, { label: "Authentication", casing: 'capitalize', children: 
            _jsx(PanelRow, { children: 
              _jsx(PasswordResetLink, { viewerRef: viewer,} )
            })
          })
        )
        , _jsx(Panel, { label: "Email Notifications" , casing: 'capitalize', children: 
          _jsx(PanelRow, { children: 
            _jsx(EmailNotifications, { viewerRef: viewer,} )
          })
        })
        , _jsx(Panel, { label: "Danger Zone" , casing: 'capitalize', children: 
          _jsx(PanelRow, { children: 
            _jsx(DeleteAccount, {} )
          })
        })
      ]})
    })
  )
}

export default UserProfile
